








import type { PropType } from '@nuxtjs/composition-api';
import { defineComponent } from '@nuxtjs/composition-api';

import { useDeclination } from '~/diptyqueTheme/composable';
import type { StoryTellingModel } from '~/diptyqueTheme/types/contentful';

export default defineComponent({
  name: 'StoryTellingContent',
  components: {
    DesktopDeclination1: () => import('./declinations/desktopDeclination1.vue'),
    DesktopDeclination2: () => import('./declinations/desktopDeclination2.vue'),
    MobileDeclination1: () => import('./declinations/mobileDeclination1.vue'),
    MobileDeclination2: () => import('./declinations/mobileDeclination2.vue')
  },
  props: {
    sectionData: {
      required: true,
      type: Object as PropType<StoryTellingModel>
    }
  },
  setup(props) {
    const {
      getDeclinationComponent: declinationComponent,
      getDeclinationClass: declinationClass
    } = useDeclination(props.sectionData);

    return {
      declinationComponent,
      declinationClass
    };
  }
});
